import React from "react";
import { Card, CardHeader, Tabs, Tab } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import TabContext from "@mui/lab/TabContext";
import { useHistory, useLocation } from "react-router-dom";
import { Type } from "context/MonitoringApplicationContext";
import MonitoringLayout from "components/Layouts/MonitoringLayout";

interface MonitoringTabsPanelProps {
  children: (tab: Type) => React.ReactNode;
  defaultTab?: Type;
}

const MonitoringTabsPanel: React.FC<MonitoringTabsPanelProps> = ({
  children,
  defaultTab = Type.monitoring,
}) => {
  const location = useLocation();
  const history = useHistory();
  const tab = (new URLSearchParams(location.search).get("tab") as Type) || defaultTab;

  const handleTabChange = (_: any, newValue: Type) => {
    history.push({ search: `?tab=${newValue}` });
  };

  return (
    <MonitoringLayout>
      <Card sx={{ width: "100%" }}>
        <TabContext value={tab}>
          <CardHeader
            subheader={
              <Tabs
                value={tab}
                onChange={handleTabChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="დასამონიტორინგებელი" value={Type.agreement} icon={<AssignmentIcon />} />
                <Tab label="დამონიტორინგებული" value={Type.monitoring} icon={<ArticleIcon />} />
                <Tab label="დადასტურებული" value={Type.approved} icon={<AssignmentTurnedInIcon />} />
              </Tabs>
            }
          />
          {children(tab)}
        </TabContext>
      </Card>
    </MonitoringLayout>
  );
};

export default MonitoringTabsPanel;
